import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=5f6efc57&scoped=true&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"
import style0 from "./Price.vue?vue&type=style&index=0&id=5f6efc57&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6efc57",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PriceStarter: require('/app/components/PriceStarter.vue').default,Button: require('/app/components/Button.vue').default})
